import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';
import { fadeInAnimation, fadeOutAnimation } from '@epicuro-next/ui';

const DAB_ITEM_ANIMATION_DURATION_MS = 600;
const MINIFIED_DAB_ITEM_ENTER_DURATION_MS = 300;
const MINIFIED_DAB_ITEM_ENTER_DELAY_DURATION_MS =
  DAB_ITEM_ANIMATION_DURATION_MS - MINIFIED_DAB_ITEM_ENTER_DURATION_MS;

export const fadeInOut: AnimationTriggerMetadata = trigger('fadeInOut', [
  transition(
    ':enter',
    useAnimation(fadeInAnimation, {
      params: {
        duration: MINIFIED_DAB_ITEM_ENTER_DURATION_MS,
        delay: MINIFIED_DAB_ITEM_ENTER_DELAY_DURATION_MS,
      },
    }),
  ),
  transition(
    ':leave',
    useAnimation(fadeOutAnimation, {
      params: {
        duration: 200,
        delay: 0,
      },
    }),
  ),
]);

export const slideDown: AnimationTriggerMetadata = trigger('slideDown', [
  state('full', style({ opacity: 1, transform: 'translateY(0)' })),
  state('down', style({ opacity: 0.5, transform: 'translateY(110%)' })),
  transition('full <=> down', [animate(`${DAB_ITEM_ANIMATION_DURATION_MS}ms`)]),
]);
